import createIcon from '../../createIcon';

/**
 * @component @name FmdBad
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM3LjggMiA0IDUuMjIgNCAxMC4yQzQgMTMuNTIgNi42NyAxNy40NSAxMiAyMkMxNy4zMyAxNy40NSAyMCAxMy41MiAyMCAxMC4yQzIwIDUuMjIgMTYuMiAyIDEyIDJaTTEzIDE1SDExVjEzSDEzVjE1Wk0xMyAxMUgxMVY2SDEzVjExWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FmdBad = createIcon('FmdBad', [
  [
    'path',
    {
      d: 'M12 2C7.8 2 4 5.22 4 10.2C4 13.52 6.67 17.45 12 22C17.33 17.45 20 13.52 20 10.2C20 5.22 16.2 2 12 2ZM13 15H11V13H13V15ZM13 11H11V6H13V11Z',
      key: '1ne84f',
    },
  ],
]);

export default FmdBad;
